/**
 * フレーム
 */

import { ThemeProvider } from "@emotion/react";
import { Box, BoxProps, createTheme, FormLabel, Paper } from "@mui/material";
import { SMsg, SInfoButton } from "components";
import { STheme } from "components/styles";
import { labels } from "messages/labels";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { navigateTypeState } from "states";

type Props = BoxProps &
  Partial<{
    title: string;
  }>;

export const SFrame = ({ title, children, ...props }: Props) => {
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  return (
    <ThemeProvider theme={theme}>
      <Paper variant="outlined">
        <Box>
          {title && (
            <Box
              className="handle"
              display="grid"
              gridTemplateColumns="auto 1fr"
              columnGap="10px"
              sx={{
                backgroundColor: STheme.labels.normal,
                borderColor: STheme.labels.border,
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns={"auto auto"}
                padding="2px"
              >
                {menuNavigate === "next" ? (
                  <SInfoButton
                    label={labels.buttons.back}
                    onClick={() => {
                      setMenuNavigate("prev");
                      navigate(-1);
                    }}
                  />
                ) : (
                  <></>
                )}
                <FormLabel>{title}</FormLabel>
              </Box>
              <SMsg />
            </Box>
          )}
          <Box display="grid" columnGap="1px" rowGap="2px" {...props}>
            {children}
          </Box>
        </Box>
      </Paper>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            margin: "0px",
            padding: "0px",
            height: "inherit",
            backgroundColor: STheme.frames.normal,
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: "0.85rem",
            fontWeight: "bold",
            paddingTop: "3px",
            paddingLeft: "4px",
          },
        },
      },
    },
  },
  { ...STheme }
);
